@if (productURL$ | async) { @if (pli()) { @if (!pli().isFreeGift) {
<a
  data-inline="true"
  [title]="'shopping_cart.edit.item.button.label' | translate : { '0': productName$ | async }"
  [routerLink]="productURL$ | async"
>
  <fa-icon [icon]="icon()" />
</a>
} } }
